import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Dr. Sridhar Chimalakonda",
        "NameLink": "https://iittp.ac.in/dr-sridhar-chimalakonda",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - International Institute of Information Technology Hyderabad, India",
        "AreasofInterest": "Software Engineering, Computing for Education",
        "Phone": "0877 250 3211",
        "Email": "ch@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg"
    }

]
const Faculty = [

    {
        "Name": "Prof. Venkata Ramana Badarla",
        "NameLink": "https://iittp.ac.in/dr-venkata-ramana-badarla",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India ",
        "AreasofInterest": "Wireless Networks, Cloud Computing, IOT ",
        "Phone": "0877 250 3212 ",
        "Email": "ramana@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/ramana.jpg"
    },

    {
        "Name": "Dr. Kalidas Yeturu",
        "NameLink": "https://iittp.ac.in/dr-kalidas-yeturu",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Machine Learning, Big Data Technologies",
        "Phone": "0877 250 3206",
        "Email": "ykalidas@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/kalidas.jpg"
    },
   
    {
        "Name": "Dr. Ajin George Joseph",
        "NameLink": "https://iittp.ac.in/dr-ajin-george-joseph",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India.",
        "AreasofInterest": "Reinforcement learning, Stochastic approximation algorithms",
        "Phone": "0877 250 3205",
        "Email": "ajin@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/ajin.jpeg"
    },
  
    {
        "Name": "Dr. Jaynarayan T Tudu",
        "NameLink": "https://iittp.ac.in/dr-jaynarayan-t-tudu",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India.",
        "AreasofInterest": "Power-aware Computer Architecture, Digital VLSI Test and Verification",
        "Phone": "0877 250 3205",
        "Email": "jtt@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/jaynarayan.jpg"
    },
   
    {
        "Name": "Dr. V. Mahendran",
        "NameLink": "https://iittp.ac.in/dr-v-mahendran",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Reinforcement Learning, Machine Learning for IoTs",
        "Phone": "0877 250 3207",
        "Email": "mahendran@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/mahendran.jpg"
    },
    {
        "Name": "Dr. Raghavendra Kanakagiri",
        "NameLink": "https://iittp.ac.in/dr-raghavendra-kanakagiri",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Parallel Computing",
        "Email": "raghavendra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/raghavendranew.png"
    },
    {
        "Name": "Dr. S Raja",
        "NameLink": "https://iittp.ac.in/dr-s-raja",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Institute of Mathematical Sciences, Chennai.",
        "AreasofInterest": "Theoretical Computer Science, Algorithms and Complexity",
        "Phone": "0877 250 3208",
        "Email": "raja@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/raja.jpg"
    },
    {
        "Name": "Dr. G. Ramakrishna",
        "NameLink": "https://iittp.ac.in/dr-g-ramakrishna",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Algorithmic Engineering",
        "Phone": "0877 250 3209",
        "Email": "rama@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/rama2.png"
    },

    {
        "Name": "Dr. Chalavadi Vishnu",
        "NameLink": "https://iittp.ac.in/dr-chalavadi-vishnu",
        "Position": "Assistant Professor",
        "Degree": "Ph.D. - Indian Institute of Technology Hyderabad, India",
        "AreasofInterest": "Deep Learning, Adversarial Learning",
        "Phone": "91004 53837",
        "Email": "chalavadivishnu@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Chalavadi_Vishnu-AP.png"
    }


]

const AdjunctFaculty = [

    {
        "Name": "Prof. B. Yegnanarayana ",
        "NameLink": "https://faculty.iiit.ac.in/~yegna/B.%20Yegnanarayana%20%7C%20IIIT%20Hyderabad.html",
        "Position": "Professor",
        "Degree": "Ph.D - IISc, Bangalore, India ",
        "AreasofInterest": " Digital Signal Processing,Speech, Computer Vision and Neural Networks ",
        "Phone": "",
        "Email": "yegna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Yagnanarayana.png"
    }

]

const GuestFaculty = [


    {
        "Name": "Dr. Anil R Nair",
        "NameLink": "https://www.linkedin.com/in/dr-anil-r-nair-3065838/",
        "Position": "Ph.D - Indian Institute of Technology, Bombay",
        "AreasofInterest": "Artificial Intelligence, machine learning, Reinforcement learning, machine reasoning",
        "Email": "anil.nair@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Anil_Nair.jpg"
    },
    {
        "Name": "Dr. S. Lakshmivarahan",
        "NameLink": "https://www.ou.edu/coe/cs/people/varahan",
        "Position": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Applied Mathematics and Computation: Big Data Analytics, Dynamic Data Assimilation, Machine Learning and High-performance computing",
        "Email": "karkslvarahan@gmail.com",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Lakshmivarahan_Picture.jpg"
    },
    {
        "Name": "Dr. Noor Mohamed",
        "NameLink": "https://iiitdm.ac.in/People/displayProfileFaculty.php?noor@iiitdm.ac.in",
        "Position": "Ph.D - Indian Institute of Technology, Madras",
        "AreasofInterest": "Software for VLSI Design, Computer Architecture, Network System Design, High Performance VLSI Architectures for DSP",
        "Email": "noor@iiitdm.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/noor.jpeg"
    },
    {
        "Name": "Dr. Srinivas Padmanabhuni",
        "NameLink": "https://www.linkedin.com/in/spadmanabhuni",
        "Position": "Chief mentor, Tarah.AI and Co-founder, CityMandi",
        "Degree": "Ph.D - University of Alberta",
        "AreasofInterest": "Artificial Intelligence, Machine Learning and Software Engineering",
        "Email": "srinivasp@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Srinivas.jpg"
    },
    {
        "Name": "Prof. Venkatesh Raman",
        "NameLink": "https://www.imsc.res.in/~vraman/",
        "Position": "Ph.D - University of Waterloo, Canada 1991",
        "AreasofInterest": "Parameterized complexity, Graph Algorithms, Space Efficient Data Structures and Algorithms",
        "Email": "vraman@imsc.res.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vraman.jpg"
    }


]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="COMPUTER SCIENCE & ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                
                                <h3>COMPUTER SCIENCE & ENGINEERING</h3>
                            </div>
                        </div>
                    </div>


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={4} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            {/*--------------------------- Adjunct Faculty */}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty </h3>
                                {AdjunctFaculty.map((AdjunctFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={AdjunctFaculty.NameLink}>
                                                        <img src={AdjunctFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={AdjunctFaculty.NameLink}>{AdjunctFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{AdjunctFaculty.Position}</p>
                                                    <p className="text-dark">{AdjunctFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {AdjunctFaculty.AreasofInterest}</p>

                                                    {(AdjunctFaculty.Phone !== undefined && AdjunctFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{AdjunctFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {AdjunctFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>



                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to="/team-single">
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>

                </div>
            </section >
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main